import { v4 as uuidv4 } from 'uuid';

export function debounce(func, wait) {
  let timeout;
  return function (...args) {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), wait);
  };
}

export const DateRange = [
  { key: "all", name: "All", value: "all", display: "All", label: "All" },
  { key: "week", name: "W", value: "week", display: "Week", label: "Week" },
  { key: "month", name: "M", value: "month", display: "Month", label: "Month" },
  { key: "half-year", name: "6M", value: "half-year", display: "6 Months", label: "6 Months" },
  { key: "year", name: "Y", value: "year", display: "Year", label: "Year" },
];

export const humanReadableFormatTime = (seconds) => {
  let time = "";
  if (!seconds || isNaN(seconds)){
     time = "0 sec"
  } else if (seconds < 60) {
    time = `${Math.floor(seconds)} sec`;
  } else if (seconds < 3600) {
    const mins = Math.floor(seconds / 60);
    time = `${mins} min`;
  } else {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.round((seconds % 3600) / 60);
    time = mins > 0 ? `${hrs} hr ${mins} min` : `${hrs} hr`;
  }
  return time
};

export const getPlaceholderName = (name) => {
  if (!name) return "";
  return name
    .split(" ")
    .slice(0, 2)
    .map((e) => e.charAt(0))
    .join("")
    .toUpperCase();
};

export const toggleArrayByObject = (array, newItem) => {
  const index = array.findIndex((item) => item.id == newItem.id);
  if (index !== -1) {
    return array.filter((item) => item.id != newItem.id);
  } else {
    return [...array, newItem];
  }
};

export const toggleArraySingleValue = (array, id) => {
  if (array.includes(id)) {
    return array.filter((item) => item !== id);
  } else {
    return [...array, id];
  }
};

export const removeDuplicatesByKey = (data, key) => {
  const uniqueIds = new Set();
  return data.filter(item => {
    if (!uniqueIds.has(item[key])) {
      uniqueIds.add(item[key]);
      return true;
    }
    return false;
  });
}

export const removeMatchedDataUsingKey = (alreadySelectedGroup, uniqueGroups, key) => {
  const uniqueGroupIds = uniqueGroups.map(group => group[key]);
  return alreadySelectedGroup.filter(group => !uniqueGroupIds.includes(group[key]));
}

export const removeExtraSpace = (str="") => str.trim().replace(/\s+/g, ' ');

export const getFileType = (type) => {
  if (type.startsWith("image")) {
    return "IMAGE";
  } else if (type === "application/pdf") {
    return "PDF";
  } else if (type.startsWith("audio")) {
    return "AUDIO";
  } else if (type.startsWith("video")) {
    return "VIDEO";
  } else {
    return "OTHER";
  }
};

export const getImageDimensions = async(url) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        resolve({ width: img.width, height: img.height });
      };
      img.onerror = reject;
      img.src = url;
    });
  };

export const generateSimpleUUID = () => {
  return uuidv4()
}
